module.exports = __webpack_public_path__ + "img/BannerNewMobile.7798abc5.png";